import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { IntegrationsPanel } from "@/features/admin/components/integrations-panel";
import { PageContainer } from "@fleet/ui";

function AdminIntegrationsPage() {
  return (
    <PageContainer maxWidth="5xl">
      <IntegrationsPanel />
    </PageContainer>
  );
}

export const adminIntegrationsRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/integrations",
  component: AdminIntegrationsPage,
});
